export const environments = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL || "",
  REACT_APP_COOKIE_NAME: process.env.REACT_APP_COOKIE_NAME || "",
  REACT_APP_COOKIE_REFRESH_NAME: process.env.REACT_APP_COOKIE_REFRESH_NAME || "",
  REACT_APP_ACCEPT_FILE: process.env.REACT_APP_ACCEPT_FILE || ""
};
